import { AccordionPanel as ChakraAccordionPanel } from "@chakra-ui/react";

export const AccordionPanel = ChakraAccordionPanel;
